import { render, staticRenderFns } from "./UnitExperienceCard.vue?vue&type=template&id=0a365b31&scoped=true"
import script from "./UnitExperienceCard.vue?vue&type=script&lang=js"
export * from "./UnitExperienceCard.vue?vue&type=script&lang=js"
import style0 from "./UnitExperienceCard.vue?vue&type=style&index=0&id=0a365b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a365b31",
  null
  
)

export default component.exports